import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  background: #fdfdfd;

  .loading-img {
    width: 150px;
    height: 150px;
  }

  .security-confirm-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    gap: 20px;

    .security-confirm-h1 {
      color: ${Theme.pallete.PRIMARY3};

      text-align: center;
      font-family: ${Theme.fontFamily.SECONDARY};
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    .security-confirm-span {
      color: ${Theme.pallete.PRIMARY3};

      text-align: center;
      font-family: ${Theme.fontFamily.SECONDARY};
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      margin-bottom: 30px;
    }
  }
`
